import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const ArrowBackIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M20.016 10.616V12.584H7.82401L13.416 18.2L12 19.616L3.98401 11.6L12 3.58398L13.416 4.99998L7.82401 10.616H20.016Z'
                fill='currentColor'
            />
        </>
    ),
})

ArrowBackIcon.displayName = 'ArrowBackIcon'
